<ng-template #modalLG let-modal style="border-radius: 8px">

    <div class="p-2">
        <span class="size18"> <strong>{{ documentType }} </strong> / <span style="color: #134AD3">{{ refExterne }}</span> </span>

        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>

    </div>
    <div style=" border-bottom: 1px solid #eee;"></div>
    <div class="">

        <div class=" modal-body" tabindex="0" ngbAutofocus style="padding: 0 54px 64px">
            <div *ngIf="isLoading" class="text-center p-4">
                <div class="spinner-border" role="status">
                    <span class="sr-only">Chargement...</span>
                </div>
            </div>
            
            <div *ngIf="!isLoading">
                <div class="d-flex justify-content-between">
                    <div class="mt-3 d-flex">
                        <div class="calendar" >
                            <i data-feather="calendar" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-muted">{{ documentDate }}</span> <br>
                            <span class="text-black">Date</span>
                        </div>

                    </div>

                    <div class="mt-3 d-flex">
                        <div class="check" >
                            <i data-feather="check" [size]="18"></i>
                        </div>
                        <div class="mx-2">
                            <span class="text-vert">{{ documentStatut }}</span> <br>
                            <span class="text-black">Statut</span>
                        </div>

                    </div>

                    <!-- Affichage Client pour Facture, Commande, etc. -->
                    <div class="" *ngIf="documentType !== 'Facture fournisseur' && documentType !== 'FACTURE FOURNISSEUR'">
                        <div class="border-dashed rounded text-center total-box-black d-flex flex-column justify-content-center align-items-center">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                                <div class="user">
                                <i data-feather="user" [size]="18"></i>
                                </div>
                            </div>
                            <p class="size15 text-black">{{ documentData?.client_data?.nom_client || documentData?.clients?.[0]?.nom_client || documentData?.clients?.[0]?.nom_prenom || '--' }}</p>
                            </div>
                    </div>
                    
                    <!-- Affichage Fournisseur pour Facture fournisseur -->
                    <div class="" *ngIf="documentType === 'Facture fournisseur' || documentType === 'FACTURE FOURNISSEUR'">
                        <div class="border-dashed rounded text-center total-box-black d-flex flex-column justify-content-center align-items-center">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                                <div class="user">
                                <i data-feather="user" [size]="18"></i>
                                </div>
                            </div>
                            <p class="size15 text-black">{{ documentData?.fornisseur_data?.nom_entreprise || documentData?.fornisseurs?.[0]?.nom_entreprise || documentData?.fournisseur_data?.nom_entreprise || documentData?.fournisseurs?.[0]?.nom_entreprise || '--' }}</p>
                            </div>
                    </div>

                     <div class="  " style="margin-left: 16px;">
                        <div class="border-dashed rounded text-center total-box ">
                            <div class="mt-2 mb-1 text-primary fw-bold">
                             <strong class=" size20"> {{ netPayer }} TND </strong>
                            </div>
                            <p class="size15 text-black">Montant total</p>
                        </div>
                    </div>
                </div>

                <!-- Informations Fournisseur pour Facture fournisseur -->
                <div *ngIf="(documentType === 'Facture fournisseur' || documentType === 'FACTURE FOURNISSEUR') && (documentData?.fornisseur_data || documentData?.fornisseurs?.[0] || documentData?.fournisseur_data || documentData?.fournisseurs?.[0])" 
                     class="d-flex justify-content-between mt-4 mb-3" style="flex-wrap: wrap; gap: 16px;">
                    <div class="d-flex flex-column" style="flex: 1; min-width: 200px;">
                        <p class="size15 fw-bold mb-1">Fournisseur</p>
                        <p class="size15-400">{{ documentData?.fornisseur_data?.nom_entreprise || documentData?.fornisseurs?.[0]?.nom_entreprise || documentData?.fournisseur_data?.nom_entreprise || documentData?.fournisseurs?.[0]?.nom_entreprise || '--' }}</p>
                    </div>
                    <div class="d-flex flex-column" style="flex: 1; min-width: 200px;">
                        <p class="size15 fw-bold mb-1">Adresse</p>
                        <p class="size15-400">{{ getFournisseurAddress() }}</p>
                    </div>
                    <div class="d-flex flex-column" style="flex: 1; min-width: 200px;">
                        <p class="size15 fw-bold mb-1">Téléphone</p>
                        <p class="size15-400 text-primary fw-bold">{{ getFournisseurTelephone() }}</p>
                    </div>
                </div>

                <!-- Onglets -->
                <div class="d-flex align-items-center gap-2 mt-4 mb-3" style="overflow-x: auto;">
                    <!-- Onglet Articles -->
                    <button 
                        type="button"
                        class="tab-button"
                        [class.tab-active]="activeTab === 'articles'"
                        [class.tab-inactive]="activeTab !== 'articles'"
                        (click)="setActiveTab('articles')">
                        <i data-feather="user" [size]="16"></i>
                        <span>Articles</span>
                    </button>

                    <!-- Onglet Paiement -->
                    <button 
                        type="button"
                        class="tab-button"
                        [class.tab-active]="activeTab === 'paiement'"
                        [class.tab-inactive]="activeTab !== 'paiement'"
                        (click)="setActiveTab('paiement')">
                        <i data-feather="dollar-sign" [size]="16"></i>
                        <span>Paiement</span>
                    </button>

                    <!-- Onglet Documents Liés -->
                    <button 
                        type="button"
                        class="tab-button"
                        [class.tab-active]="activeTab === 'documents'"
                        [class.tab-inactive]="activeTab !== 'documents'"
                        (click)="setActiveTab('documents')">
                        <i data-feather="lock" [size]="16"></i>
                        <span>Documents Liés</span>
                    </button>
                </div>

                <div class="detail-popup-tabs-body">
                <!-- Contenu de l'onglet Articles -->
                <div *ngIf="activeTab === 'articles'" class="tab-content detail-inventaire-tab-panel">
                    <app-detail-document-product-table
                        [sourceLignes]="getDetailProductTableSourceLignes()"
                        [firstPriceLabel]="getDetailFirstPriceLabel()"
                        [secondPriceLabel]="getDetailSecondPriceLabel()"
                        [refGroupCollapsedSecondPriceIsDash]="!isFactureFournisseur()">
                    </app-detail-document-product-table>

                    <div class="d-flex justify-content-between align-items-end mt-3 detail-popup-tab-footer">
                        <!-- Bouton Retenue à la source - Affiché uniquement pour FACTURE et FACTURE FOURNISSEUR avec retenue à la source -->
                        <div class="d-flex align-items-center">
                            <button 
                                *ngIf="hasRetenueSource && (documentType === 'Facture' || documentType === 'FACTURE' || documentType === 'Facture fournisseur' || documentType === 'FACTURE FOURNISSEUR')"
                                type="button" 
                                class="btn-retenue-source" 
                                (click)="generateRetenueSource()">
                                <i data-feather="file-text" [size]="18"></i>
                                <span>Retenue à la source</span>
                            </button>
                        </div>
                        
                        <!-- Bénéfice total - Toujours affiché à droite -->
                        <div class="border-dashed rounded text-center benef-box">
                            <div class="mt-2 mb-1 benef-title">
                              <strong class="size20">  {{ calculateBenefice() }} TND</strong>
                            </div>
                            <p class="mb-1 size15">Bénéfice total</p>
                        </div>
                    </div>
                </div>

                <!-- Contenu de l'onglet Paiement -->
                <div *ngIf="activeTab === 'paiement'" class="tab-content detail-inventaire-tab-panel">
                    <div class="detail-inventaire-table-scroll detail-inventaire-table-scroll--secondary mx-1">
                        <table class="styled-table w-full mb-0">
                            <thead>
                            <tr>
                                <th>DATE</th>
                                <th>MONTANT</th>
                                <th>MODE DE PAIEMENT</th>

                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="paiements.length === 0">
                                <td colspan="4" class="text-center text-muted">Aucun paiement enregistré</td>
                            </tr>
                            <tr *ngFor="let paiement of paiements">
                                <td>{{ formatDate(paiement.date) }}</td>
                                <td>{{ paiement.montant ? formatPrice(paiement.montant) : '--' }} TND</td>
                                <td>{{ paiement.mode_paiement || '--' }}</td>

                            </tr>
                            </tbody>
                        </table>
                    </div>
                        <!-- Total des paiements -->
                        <div *ngIf="paiements.length > 0" class="d-flex justify-content-end mt-3 detail-popup-tab-footer">
                            <div class="border-dashed rounded text-center" style="min-width: 189px; height: 102px; border: 1px dashed #134AD3; padding: 10px;">
                                <div class="mt-2 mb-1 text-primary fw-bold">
                                    <strong class="size20">{{ calculateTotalPaiements() }} TND</strong>
                                </div>
                                <p class="mb-1 size15">Total payé</p>
                            </div>
                        </div>
                </div>

                <!-- Contenu de l'onglet Documents Liés -->
                <div *ngIf="activeTab === 'documents'" class="tab-content detail-inventaire-tab-panel">
                    <div class="detail-inventaire-table-scroll detail-inventaire-table-scroll--secondary mx-1">
                        <table class="styled-table w-full mb-0">
                            <thead>
                            <tr>
                                <th>RÉFÉRENCE</th>
                                <th>TYPE</th>
                                <th>DATE</th>
                                <th>MONTANT</th>
                                <th>STATUT</th>
                                <th>ACTIONS</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngIf="documentsLies.length === 0">
                                <td colspan="6" class="text-center text-muted">Aucun document lié</td>
                            </tr>
                            <tr *ngFor="let doc of documentsLies">
                                <td>{{ doc.reference || '--' }}</td>
                                <td>{{ doc.type || '--' }}</td>
                                <td>{{ formatDate(doc.date) }}</td>
                                <td>{{ doc.montant ? formatPrice(doc.montant) : '--' }} TND</td>
                                <td>
                                    <span class="badge" 
                                          [class.badge-success]="doc.statut === 'Payé' || doc.statut === 'Payée' || doc.statut === 'Partiellement payé' || doc.statut === 'Validée'"
                                          [class.badge-info]="doc.statut === 'Non payé' || doc.statut === 'Crée' || doc.statut === 'Livré' || doc.statut === 'Valide' || doc.statut === 'Reçu'"
                                          [class.badge-danger]="doc.statut === 'Annulé' || doc.statut === 'Annulée'"
                                          style="padding: 4px 8px; font-size: 12px;">
                                        {{ doc.statut || '--' }}
                                    </span>
                                </td>
                                <td class="d-flex align-items-center gap-1">
                                    <a href="javascript:void(0)" class="action-icon" (click)="editDocumentLie(doc); $event.preventDefault()" title="Modifier le document" style="color: rgba(47, 43, 61, 0.7);">
                                        <span data-feather="edit" [attr.width]="18" [attr.height]="18"></span>
                                    </a>
                                    <a href="javascript:void(0)" class="action-icon" (click)="downloadDocumentLie(doc); $event.preventDefault()" title="Télécharger" style="color: rgba(47, 43, 61, 0.7);">
                                        <span data-feather="download" [attr.width]="18" [attr.height]="18"></span>
                                    </a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                </div>
            </div>
        </div>


    </div>
</ng-template>
